/* eslint-disable no-console */
/* eslint-disable func-names */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable vars-on-top */
/* eslint-disable max-len */
/* eslint-disable no-var */
/* eslint-disable consistent-return */
/* eslint-disable no-loop-func */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Lock from '@material-ui/icons/Lock';
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import red from '@material-ui/core/colors/red';
import FormControl from '@material-ui/core/FormControl';
import { FormField } from '@iris-platform/iris-react-ui';
import { withSnackbar } from 'notistack';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import { Query, withApollo } from 'react-apollo';
import {
  curry,
  propEq,
  map,
  compose,
  contains,
  pathOr,
  prop,
  when,
  set,
  lensPath,
} from 'ramda';
import { components as commonComponents } from '@555platform/portal-components/lib/client';
import {
  ASSOCIATE_USER_WITH_TEAM,
} from '../../../components/TeamsManager/queries';
import {
  getPopUsers,
} from './queries';
import CopyRoleForm from './CopyRoleForm';
import { RolesContainer } from './RolesContainer';


const ERROR_MESSAGE_TTL_MS = 5000;

const styles = theme => ({
  backButton: {
    marginRight: theme.spacing.unit,
    fontSize: '14px',
  },
  backButtonHidden: {
    display: 'none',
    marginRight: theme.spacing.unit,
    fontSize: '14px',
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  button: {
    fontSize: '14px',
    color: '#FFFFFF',
  },
  card: {
    minWidth: 275,
    overflow: 'visible',
  },
  buttons: {
    marginTop: '1rem',
  },
  buttonProgress: {
    color: red[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  error: {
    width: '100%',
    textAlign: 'center',
    color: '#b61402',
    animation: `inOut ${ERROR_MESSAGE_TTL_MS / 1000}s linear`,
  },
  '@keyframes inOut': {
    '0%': {
      height: '0em',
      opacity: '0',
    },
    '4%': {
      height: '1em',
      opacity: '1',
    },
    '96%': {
      height: '1em',
      opacity: '1',
    },
    '100%': {
      height: '0em',
      opacity: '0',
    },
  },
});

const useStyles = () => ({
  input: {
    display: 'none',
  },
});

var selectedUsers = [];

const getSteps = () => ['Provide Role name and type', 'Select Permissions'];

const isDuplicateKeyError = compose(
  contains('E11000 duplicate key error collection'),
  pathOr('', ['message']),
);

class UpdateRole extends Component {
  state = {
    activeStep: 0,
    displayName: '',
    team: '',
    name: '',
    creatingRole: false,
    error: null,
    roleTeam: '',
  };

  onPermissionChange = curry((handlers, roleIdentifier, resource, action, isEnabled) => {
    const { allowFn, removeFn } = handlers;
    return isEnabled
      ? allowFn({ variables: { action, resource, roleIdentifier } })
      : removeFn({ variables: { action, resource, roleIdentifier } });
  });

  mutate = async (mutation, createUpdate, description = 'update role') => {
    const { client, enqueueSnackbar } = this.props;

    this.setState({
      error: null,
      loading: true,
    });

    try {
      const { data } = await client.mutate(mutation);

      this.setState(state => ({
        loading: false,
        ...createUpdate(data, state),
      }));
      enqueueSnackbar('Successfully updated role', { variant: 'success' });
      return data;
    } catch (error) {
      this.setState({
        loading: false,
      });
      enqueueSnackbar('Unable to update role', { variant: 'error' });
      return {};
    }
  };

  changeRole = (userId, role) => {
    var teamId = this.state.team_id;
    this.mutate(
      {
        mutation: ASSOCIATE_USER_WITH_TEAM,
        variables: { userId, teamId, role },
      },
      ({ associateUserWithTeam: updatedUser }, state) => ({
        users: map(
          when(
            propEq('user_id', updatedUser.user_id),
            set(lensPath(['auminfo', 'roles']), updatedUser.auminfo.roles),
          ),
          state.users,
        ),
      }),
      'update role',
    );
  }

  setUpBoxes = (users) => {
    if (users) {
      var boxes = [];
      var classes = useStyles();
      for (var x in users) {
        if (users[x].auminfo.roles.includes(`${this.state.team}:${this.state.name}`)) {
          boxes.push(
            <TableRow>
              <TableCell padding="checkbox">
                <Checkbox
                  value={String(users[x].user_id)}
                  id={String(users[x].user_id)}
                  inputProps={{ 'aria-label': 'uncontrolled-checkbox' }}
                  onChange={(event) => {
                    if (event.target.checked && selectedUsers.includes(event.target) === false) {
                      selectedUsers.push(event.target);
                    } else if (event.target.checked === false && selectedUsers.includes(event.target.value)) {
                      selectedUsers = selectedUsers.filter(team => team !== event.target);
                    }
                  }}
                />
                <TableSortLabel>
                  {String(users[x].auminfo.email)}
                </TableSortLabel>
              </TableCell>
            </TableRow>
            ,
          );
        }
      }
      boxes.push(
        <div>
          <Button
            className={classes.button}
            onClick={() => {
              for (var i in users) {
                var target = document.getElementById(String(users[i].user_id));
                if (target.checked === false) {
                  target.click();
                }
              }
            }
            }
          >
              Select All
          </Button>
        </div>,
      );
      return boxes;
    }
  }

  onTeamSelect = (selectedTeam) => {
    this.setState({
      roleTeam: selectedTeam,
      team: selectedTeam.code,
      team_id: selectedTeam.code,
    });
  }

  onRoleSelection = (selectedRole) => {
    this.setState({
      displayName: selectedRole.description,
      permissions: selectedRole.permissions,
      role: selectedRole,
    });
  }

  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }));
  };

  handleNext = async (handler) => {
    const {
      displayName, team, name,
    } = this.state;
    this.setState({ creatingRole: true });

    if (displayName === '' || team === '' || name === '') {
      this.setState({
        error: new Error('Both name and team values are required'),
        creatingRole: false,
      });
      return;
    }

    const roleIdentifier = {
      name,
      displayName,
      team,
    };

    try {
      await handler({ variables: { roleIdentifier } });
    } catch (err) {
      if (isDuplicateKeyError(err)) {
        this.setState({ error: new Error('Role with this name already exists') });
      } else {
        this.setState({ error: new Error('Could not update role, try again later') });
      }

      this.setState({ creatingRole: false });
      return;
    }

    this.setState(state => ({
      activeStep: state.activeStep + 1,
      creatingRole: false,
      name,
    }));
  };

  getStepContent = () => {
    const {
      activeStep, name, roleTeam,
    } = this.state;
    const { classes } = this.props;
    switch (activeStep) {
      case 0:
        var updateForm = [];
        updateForm.push(
          <div>
            <FormControl
              className={classes.formRoot}
            />
            <FormField
              placeholder="Role name"
              value={name}
              onChange={(e) => {
                this.setState({ name: e.target.value });
              }}
            />
          </div>,
        );
        updateForm.push(
          <CopyRoleForm
            onTeamSelect={this.onTeamSelect}
            onRoleSelection={this.onRoleSelection}
            roleTeam={roleTeam}
          />,
        );
        return updateForm;

      case 1:
        return (
          <Query
            query={getPopUsers}
            notifyOnNetworkStatusChange
            variables={{ filter: '', skip: 0, limit: 0 }}
          >
            {({ data, error }) => {
              if (error) {
                return (
                  <FormHelperText
                    error
                  >
                    Unable to load users
                  </FormHelperText>
                );
              }
              var { users } = data;
              if (users) {
                return (
                  <Paper className={classes.root}>
                    <Table className={classes.table}>
                      <TableHead>
                        <TableRow>
                          <TableCell>Users</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.setUpBoxes(users.users)}
                      </TableBody>
                    </Table>
                  </Paper>
                );
              }
              return null;
            }}
          </Query>
        );
      default:
        return 'Uknown stepIndex';
    }
  };

  render() {
    const { classes, history } = this.props;
    const steps = getSteps();
    const { activeStep, creatingRole, error } = this.state;

    if (error) {
      setTimeout(() => this.setState({ error: null }), ERROR_MESSAGE_TTL_MS + 50);
    }

    return (
      <RolesContainer>
        {() => (
          <commonComponents.Panel
            title="Update Role"
            avatar={(
              <Avatar>
                <Lock />
              </Avatar>
            )}
          >
            <div>
              {error && <div className={classes.error}>{prop('message', error)}</div>}
              <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map(label => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <div>
                <Card className={classes.card}>
                  <CardContent>{this.getStepContent()}</CardContent>
                </Card>
                <div className={classes.buttons}>
                  <Button
                    onClick={activeStep === 0 ? () => history.goBack() : this.handleBack}
                    className={activeStep === 0 ? classes.backButton : classes.backButtonHidden}
                  >
                    {activeStep === 0 ? 'Back to Role List' : 'Back'}
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={
                      activeStep === steps.length - 1
                        ? () => {
                          for (var x in selectedUsers) {
                            this.changeRole(selectedUsers[x].id, this.state.role.code);
                          }
                          return history.goBack();
                        }
                        : () => {
                          this.setState({ activeStep: 1 });
                          return this.getStepContent();
                        }
                        }
                    className={classes.button}
                    disabled={creatingRole}
                  >
                    {activeStep === steps.length - 1 ? 'Finish' : 'Select Users'}
                    {creatingRole && (
                      <CircularProgress size={24} className={classes.buttonProgress} />
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </commonComponents.Panel>
        )}
      </RolesContainer>
    );
  }
}

UpdateRole.propTypes = {
};

const UpdateRoleWithClient = (withApollo(UpdateRole));
const StyledUpdateRole = (withStyles(styles)(UpdateRoleWithClient));

export default withSnackbar(StyledUpdateRole);
